import {withKnownRoute} from '../../lib/routes';
import {GlossaryPage} from './glossary-page';

export default withKnownRoute(GlossaryPage);
